import React from "react";
import { CARD_BASE } from "../../constants/layout";
import PropTypes from "prop-types";

export const Card = ({ 
  children, 
  className = "", 
  padding = true,
  as: Component = "div",
  ...props 
}) => (
  <Component 
    className={`${CARD_BASE} ${padding ? 'p-4' : ''} ${className}`} 
    {...props}
  >
    {children}
  </Component>
);

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  padding: PropTypes.bool,
  as: PropTypes.elementType
};

export default Card; 